import { PageHeader } from '@/components/PageHeader';
import { ReleasesList } from '@/features/releases/components/ReleasesList';

export function ReleasesListPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Releases" />
      <ReleasesList />
    </div>
  );
}
